var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    {
      staticClass: "mt-6",
      attrs: { title: "Background", body: "Tell companies more about you" },
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-2" },
        [
          _c(
            "FormGroup",
            { attrs: { title: "Skills (30 Max)" } },
            [
              _vm.profile
                ? _c("SkillsMultiselect", {
                    attrs: {
                      max: 30,
                      getParentStyle: "customWidthInput",
                      placeholder: "Select skills",
                      withCustomSkills: true,
                      companyId: _vm.companyId,
                    },
                    model: {
                      value: _vm.skillsIds,
                      callback: function ($$v) {
                        _vm.skillsIds = $$v
                      },
                      expression: "skillsIds",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "FormGroup",
            { staticClass: "mt-2", attrs: { title: "Soft Skills (30 Max)" } },
            [
              _vm.profile
                ? _c("SoftSkillsMultiselect", {
                    attrs: {
                      max: 30,
                      getParentStyle: "customWidthInput",
                      placeholder: "Select soft skills",
                      withCustomSoftSkills: true,
                      companyId: _vm.companyId,
                    },
                    model: {
                      value: _vm.softSkillsIds,
                      callback: function ($$v) {
                        _vm.softSkillsIds = $$v
                      },
                      expression: "softSkillsIds",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "FormGroup",
            { staticClass: "mt-2", attrs: { title: "Industries (10 Max)" } },
            [
              _c("IndustriesMultiselect", {
                attrs: { max: 10 },
                model: {
                  value: _vm.industries,
                  callback: function ($$v) {
                    _vm.industries = $$v
                  },
                  expression: "industries",
                },
              }),
            ],
            1
          ),
          _c(
            "FormGroup",
            { staticClass: "mt-2", attrs: { title: "Languages (5 Max)" } },
            [
              _c("LanguagesMultiselect", {
                attrs: { max: 5 },
                model: {
                  value: _vm.languages,
                  callback: function ($$v) {
                    _vm.languages = $$v
                  },
                  expression: "languages",
                },
              }),
            ],
            1
          ),
          _c(
            "FormGroup",
            {
              staticClass: "mt-2",
              attrs: { title: "What transportation methods do you use?" },
            },
            [
              _c("TransportationMultiselect", {
                attrs: { max: 4 },
                model: {
                  value: _vm.transportation,
                  callback: function ($$v) {
                    _vm.transportation = $$v
                  },
                  expression: "transportation",
                },
              }),
            ],
            1
          ),
          _c(
            "FormGroup",
            {
              staticClass: "mt-2",
              attrs: { title: "Maximum Available Hours Per Week" },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.maxAvailableHours,
                    expression: "maxAvailableHours",
                    modifiers: { number: true },
                  },
                ],
                staticClass:
                  "w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500",
                attrs: {
                  type: "number",
                  min: "1",
                  max: "80",
                  placeholder: "Enter hours (1-80)",
                },
                domProps: { value: _vm.maxAvailableHours },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.maxAvailableHours = _vm._n($event.target.value)
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _c("p", { staticClass: "text-sm text-gray-500 mt-1" }, [
                _vm._v("How many hours per week are you available to work?"),
              ]),
            ]
          ),
          _c(
            "FormGroup",
            { attrs: { title: "Summary" } },
            [
              _c("FormTextarea", {
                attrs: { name: "profile_summary", placeholder: "Summary" },
                model: {
                  value: _vm.summary,
                  callback: function ($$v) {
                    _vm.summary = $$v
                  },
                  expression: "summary",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("UiButton", {
        staticClass: "flex justify-end mt-2 pt-3",
        attrs: {
          buttonText: "Save",
          variant: "black",
          processing: _vm.$apollo.queries.profile.loading,
        },
        on: { click: _vm.updateProfileDetail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }